'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reduxForm = require('redux-form');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _components = require('../../components');
var _constants = require('./constants');var _constants2 = _interopRequireDefault(_constants);
var _RegistrationContainer = require('./RegistrationContainer.scss');var styles = _interopRequireWildcard(_RegistrationContainer);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

RegistrationConfirmPhoneModal = function (_React$Component) {_inherits(RegistrationConfirmPhoneModal, _React$Component);function RegistrationConfirmPhoneModal() {_classCallCheck(this, RegistrationConfirmPhoneModal);return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));}RegistrationConfirmPhoneModal.prototype.
  render = function render() {var _props =








    this.props,isOpen = _props.isOpen,onClose = _props.onClose,translate = _props.translate,phone = _props.phone,children = _props.children,renderInput = _props.renderInput,validateInputValue = _props.validateInputValue;
    return (
      _react2.default.createElement(_components.Modal, { isOpen: isOpen, className: styles.modal, onRequestClose: onClose },
        _react2.default.createElement('div', { className: styles.modalContentWrapper },
          _react2.default.createElement('p', { className: styles.modalTitle },
            translate('authenticationPage', 'confirm_phone_number')),

          _react2.default.createElement('div', { className: styles.modalSubTitleWrapper },
            _react2.default.createElement('p', { className: styles.modalSubTitle },
              translate('authenticationPage', 'confirmation_code_sent')),

            _react2.default.createElement('p', { className: styles.modalPhoneNumber }, phone),
            _react2.default.createElement('p', { className: styles.modalSubTitle },
              translate('authenticationPage', 'enter_code_below'))),


          _react2.default.createElement('div', { className: styles.codeFieldWrapper },
            _react2.default.createElement(_reduxForm.Field, {
              name: _constants2.default.CODE,
              type: 'text',
              maxLength: '4',
              component: renderInput,
              validate: validateInputValue,
              placeholder: translate('authenticationPage', 'code') })),


          children)));



  };return RegistrationConfirmPhoneModal;}(_react2.default.Component);


RegistrationConfirmPhoneModal.propTypes = {
  isOpen: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  phone: _propTypes2.default.string,
  renderInput: _propTypes2.default.func,
  validateInputValue: _propTypes2.default.func,
  children: _propTypes2.default.node };exports.default =


RegistrationConfirmPhoneModal;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RegistrationContainer/ConfirmPhoneModal.js
// module id = 3070
// module chunks = 0